/*eslint-disable*/
import PropTypes from "prop-types";
import { connect } from "react-redux";

import BlogQuery from "Query/Blog.query";
import { showNotification } from "Store/Notification/Notification.action";
import DataContainer from "Util/Request/DataContainer";

import Blog from "./Blog.component";

/** @namespace Component/Services/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
});

/** @namespace Component/Services/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    showNotification: (type, title, error) =>
        dispatch(showNotification(type, title, error)),
});

/** @namespace Component/PopularCategory/Container */
export class BlogContainer extends DataContainer {
    static propTypes = {
        showNotification: PropTypes.func.isRequired,
    };

    state = {
        blogs: {},
    };

    componentDidMount() {
        this.requestBlogs();
    }

    requestBlogs() {
        const { showNotification } = this.props;

        this.fetchData(
            [BlogQuery.getQuery()],
            ({ blogs }) => this.setState({ blogs }),
            (e) => showNotification("error", __("Error fetching blog data!"), e)
        );
      
    }

    render() {
        return <Blog {...this.props} {...this.state} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogContainer);
